var _a;
import React from "react";
import App from "./App";
import "./i18n";
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import AppThemeProvider from "./ui/theme";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Provider } from "react-redux";
import { store } from "./app/store";
import AuthProvider from "./auth/AuthProvider";
import { CompanyProvider } from "./context/CompanyContext";
import { PermissionProvider } from "./context/PermissionContext";
import { SnackbarProvider } from "notistack";
const container = (_a = document.getElementById("root")) !== null && _a !== void 0 ? _a : document.createElement("root");
const root = createRoot(container);
root.render(React.createElement(I18nextProvider, { i18n: i18n },
    React.createElement(BrowserRouter, null,
        React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
            React.createElement(AppThemeProvider, null,
                React.createElement(Provider, { store: store },
                    React.createElement(AuthProvider, null,
                        React.createElement(PermissionProvider, null,
                            React.createElement(CompanyProvider, null,
                                React.createElement(SnackbarProvider, { maxSnack: 3, autoHideDuration: 2000, anchorOrigin: {
                                        vertical: "top",
                                        horizontal: "right",
                                    } },
                                    React.createElement(App, null)))))))))));
